
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/[tickerSymbol]/quotes",
      function () {
        return require("private-next-pages/us/[tickerSymbol]/quotes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/[tickerSymbol]/quotes"])
      });
    }
  